import React, { ForwardedRef } from 'react';

import cx from 'classnames';
import { Row } from 'react-table';

interface RowProps<T extends object>
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  row?: Row<T>;
  header?: boolean;
  selectedRows: any;
}

export const WorkspaceItemTableRow = React.forwardRef(function TableRow<
  T extends object
>(
  { children, row, header, selectedRows }: RowProps<T>,
  ref: ForwardedRef<HTMLDivElement>
) {
  const className = cx(
    'w-full flex flex-row cursor-pointer',
    { ['z-20 sticky top-0 bg-white']: header },
    { ['bg-cyan-50']: row && selectedRows.includes(row) }
  );
  return (
    <div
      ref={ref}
      className={className}
      style={{
        borderTop: header ? '1px solid rgb(232, 237, 240)' : 0,
        borderBottom: '1px solid rgb(232, 237, 240)',
        height: '54px',
      }}
    >
      {children}
    </div>
  );
});
